/**
 * The per-company feature flags, as shown in the company Config modal and the
 * per-user flags modal. Keys match `Company.feature_flags` on the backend
 * (`COMPANY_FEATURE_FLAG_KEYS`); every flag listed here is offered in both
 * modals, so a user override can be set for any flag a company has.
 */
export type TFeatureFlagDefinition = {
    key: string;
    label: string;
    description: string;
};

export const FEATURE_FLAG_DEFINITIONS: readonly TFeatureFlagDefinition[] = [
    {
        key: "email_communications_enabled",
        label: "Email Communications",
        description:
            "Show the Email Communications log page to this company's Product Owners. PRODA users always have access.",
    },
    {
        key: "homepage_v2_enabled",
        label: "Homepage board",
        description:
            "Replace the All Files and Financial TB/GL lists with the submissions board. Off leaves the legacy pages in place. Outside production the board is already on by default; saving this box off switches it off.",
    },
    {
        key: "operating_statement_enabled",
        label: "Operating statement",
        description:
            "Offer the operating statement (income statement) view of Trial Balance files on the review page. Outside production it is already on by default; saving this box off switches it off.",
    },
];

/**
 * Turn the modal's checkbox state into the overrides to store for a user:
 * a value equal to the company's is not an override (null clears any
 * previous one), a differing value is stored explicitly.
 */
export function overridesFromEffective(
    effective: Record<string, boolean>,
    companyFlags: Record<string, boolean>,
): Record<string, boolean | null> {
    const overrides: Record<string, boolean | null> = {};
    for (const { key } of FEATURE_FLAG_DEFINITIONS) {
        const value = effective[key] ?? false;
        overrides[key] = value === (companyFlags[key] ?? false) ? null : value;
    }
    return overrides;
}
